import { Eye } from "lucide-react";

export function ReadOnlyBanner() {
  return (
    <div style={{ padding: "8px 14px", marginBottom: 12, background: "rgba(245,158,11,0.08)", border: "1px solid rgba(245,158,11,0.2)", borderRadius: 10, display: "flex", alignItems: "center", gap: 8 }}>
      <Eye size={14} style={{ color: "#f59e0b", flexShrink: 0 }} />
      <span style={{ fontSize: 12, color: "rgba(245,158,11,0.8)" }}>View Only — your role does not have edit access on this page</span>
    </div>
  );
}
